<script setup>
import { computed, inject } from 'vue'
import { CDN } from '@/__core__/cdn/cdn'
import { loc } from '@/__core__/localization/localization'

defineProps({
  stadiumData: Object,
})

const status = inject('status')
const langId = inject('langId', '')
const imageUrl = computed(() => `${CDN.getCdnUrl() === '/' ? 'http://127.0.0.1:3030' : CDN.getCdnUrl()}/images/stadium-team_profile.png`)
</script>

<template>
  <template v-if="status === 'loading'">
    <div class="szw-flex szw-bg-latest-background-color-secondary szw-rounded-2 szw-justify-between szw-items-center szw-p-1 szw-border szw-border-border szw-border-solid">
      <div class="szw-flex szw-flex-col szw-justify-center szw-h-[80px] szw-gap-1 szw-px-1 szw-pt-1">
        <div class="szw-w-[100px] szw-bg-section-static szw-h-[16px] szw-rounded-1 szw-animate-pulse"></div>
        <div class="szw-w-[160px] szw-bg-section-static szw-h-[14px] szw-rounded-1 szw-animate-pulse"></div>
        <div class="szw-w-[140px] szw-bg-section-static szw-h-[14px] szw-rounded-1 szw-animate-pulse"></div>
      </div>
      <div>
        <img :src="imageUrl" alt="stadium" class="szw-mix-blend-multiply">
      </div>
    </div>
  </template>

  <template v-if="status === 'success'">
    <div class="szw-flex szw-bg-latest-background-color-secondary szw-rounded-2 szw-justify-between szw-items-center szw-p-1 szw-border szw-border-border szw-border-solid">
      <div class="szw-flex szw-flex-col szw-justify-center szw-h-[80px] szw-gap-1 szw-px-1">
        <div class="szw-font-medium szw-text-xs szw-leading-[16px]">{{ loc('sm_home_stadium', langId) }}</div>
        <div class="szw-font-light szw-text-[12px] szw-leading-[14px]"> {{ stadiumData.name }}, {{ stadiumData.location?.city }}</div>
        <div class="szw-font-light szw-text-[12px] szw-leading-[14px]"> {{ loc('sm_venue_capacity', langId) }}: {{ stadiumData.capacity }}</div>
      </div>
      <div>
        <img :src="imageUrl" alt="stadium" class="szw-mix-blend-multiply">
      </div>
    </div>
  </template>
</template>
